import React from 'react';
import styled, { css } from 'styled-components';

import { convertThumbnailToPictureProps } from '@tager/web-modules';

import Picture from '@/components/Picture';
import { ButtonNextLink } from '@/components/Button';
import { media } from '@/utils/mixin';

import { PostReviewCardProps } from './types';

function PostReviewCard({
  image,
  title,
  description,
  buttonTitle = 'Читать обзор',
  buttonLink,
}: PostReviewCardProps) {
  return (
    <Component>
      <Left>
        <Image
          loading="lazy"
          {...convertThumbnailToPictureProps(image)}
          alt={title}
        />

        <Content>
          <Title>{title}</Title>
          <Description>{description}</Description>
        </Content>
      </Left>

      <Right>
        <ButtonNextLink to={buttonLink} variant="outlined">
          {buttonTitle}
        </ButtonNextLink>
      </Right>
    </Component>
  );
}

export default PostReviewCard;

const Component = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  border-radius: 10px;
  background: ${(props) => props.theme.gray_1};

  ${media.mobile(css`
    flex-direction: column;
    align-items: flex-start;
  `)}
`;

const Image = styled(Picture)`
  flex: 0 0 165px;
  max-width: 165px;
  height: 100px;

  ${media.mobile(css`
    flex: 0 0 100px;
    max-width: 100px;
    height: 80px;
  `)}

  picture,
  img {
    width: 100%;
    height: 100%;
    border-radius: 6px;
  }

  img {
    object-fit: cover;
  }
`;

const Content = styled.div`
  margin-left: 20px;
`;

const Left = styled.div`
  flex: 1;
  display: flex;
  align-items: center;

  ${media.mobile(css`
    width: 100%;
  `)}
`;

const Title = styled.p`
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  color: ${(props) => props.theme.black};
`;

const Description = styled.p`
  font-size: 14px;
  line-height: 16px;
  margin-top: 5px;
  color: ${(props) => props.theme.blue100};
`;

const Right = styled.div`
  display: flex;
  width: 100%;
  max-width: 200px;
  margin-left: 20px;

  ${media.mobile(css`
    max-width: none;
    margin: 20px 0 0;
  `)}
`;
